module.exports = __webpack_public_path__ + "img/info.03e81694.png";